// Use the reaction side, never the author of the reacted-to message.
export function whatsappReactionChips({ reactions, sourceId = '', inboxName, conversation, conversationId, inboxId }) {
  sourceId = typeof sourceId === 'string' ? sourceId : '';
  if (!reactions || typeof reactions !== 'object' || Array.isArray(reactions)) return [];
  const name = value => typeof value === 'string' ? value.trim() : '';
  const sameConversation = conversation && Number(conversation.id) === Number(conversationId) &&
    Number(conversation.inbox_id ?? conversation.inboxId) === Number(inboxId);
  // A group participant cannot be identified from the conversation contact.
  const attributes = conversation?.meta?.sender?.custom_attributes ?? conversation?.meta?.sender?.customAttributes ?? {};
  const chatIds = [attributes.waha_whatsapp_chat_id, attributes.waha_whatsapp_jid, attributes.waha_whatsapp_lid];
  const group = sourceId.includes('@g.us') || (sameConversation && chatIds.some(id => typeof id === 'string' && id.endsWith('@g.us')));
  const linkedDirect = sameConversation && chatIds.some(id => typeof id === 'string' && /^[^_\s]+@(?:c\.us|s\.whatsapp\.net|lid)$/.test(id));
  const directSource = /^(?:true|false)_[^_\s]+@(?:c\.us|s\.whatsapp\.net|lid)_[^\s]+$/.test(sourceId);
  const contact = sameConversation && !group && (linkedDirect || directSource) ? name(conversation.meta?.sender?.name) : '';
  const own = name(inboxName) ? `${name(inboxName)}（我方）` : '我方';
  if (!reactions || typeof reactions !== 'object' || Array.isArray(reactions)) return [];
  return Object.entries(reactions).flatMap(([key, reaction]) => {
    if (!reaction || typeof reaction.emoji !== 'string' || !reaction.emoji.trim()) return [];
    const author = reaction.self === true ? own : contact || (group ? '其他参与者' : '对方');
    return [{ key, emoji: reaction.emoji, author, label: `${author} 回应了 ${reaction.emoji}` }];
  });
}
